import { Category } from './category';

export class Proveedor {
    userID: number ;
    dealerName: string ;
    contactName: string ;
    postalAddress: string ;
    physicalAddress: string ;
    email: string ;
    phoneNumber1:string;
    phoneNumber2: string ;
    userName: string ;
    password:string;
    token?: string;
    signature:string;
    userCategories:Category[];
    parentUserID:number;
    roleID:String;

    constructor(user) {
        this.userID = (user.userID ?  user.userID : undefined);
        this.dealerName = (user.dealerName ?  user.dealerName : '');
        this.contactName = (user.contactName ?  user.contactName : '');
        this.postalAddress = (user.postalAddress ?  user.postalAddress : '');
        this.physicalAddress = (user.physicalAddress ?  user.physicalAddress : '');
        this.email = (user.email ?  user.email : '');
        this.phoneNumber1 = (user.phoneNumber1 ? user.phoneNumber1 : undefined);
        this.phoneNumber2 = (user.phoneNumber2 ? user.phoneNumber2 : undefined);
        this.userName = (user.userName ? user.userName: undefined);
        this.password = (user.password ?  user.password : '');
        this.token = (user.token ?  user.token : '');
        this.signature = (user.signature ?  user.signature : undefined);
        this.roleID =  (user.roleID ? user.roleID : undefined);;
        this.parentUserID = (user.parentUserID ? user.parentUserID : undefined);
        this.userCategories = (new Array<Category>(user.userCategories) ? user.userCategories : undefined);
    }
}
